<template>
  <div id="body">
    <div class="main_block">
      <template v-if="isWxNavigator"> 
        <div class="main_block_top">
          <div class="main_block_search">
            <input type="text" maxlength="15" v-model="search" placeholder="请输入车牌后3位或设备号">
            <button :class="!(search && search.length > 2) ? 'disabled' : ''" @click="toMiniapp">查询</button>
          </div>
          <div class="main_block_mid" v-if="snCode">
            <div class="plate_block">
              <div v-if="plate" class="plate_text">{{plate}}</div>
              <div v-else class="plate_text" style="background: #B0B2B8">未绑定车辆</div>
            </div>
            <div>{{parentNumber}}
              <span style="margin-left: 10px">{{snCode}}</span>
            </div>
          </div>
          <div class="main_block_list" v-if="dataList.length">
            <div class="main_block_listItem" v-for="(v,i) in dataList" :key="i">
              <span>{{v.item}}</span>
              <div class="listItem_right">
                <span :style="v.state != 1 ? 'color: #FA5151' : ''">{{v.value}}</span>
                <img class="state_img" v-if="v.state == 1" src="../assets/success.png">
                <img class="state_img" v-else src="../assets/error.png">
              </div>
            </div>
          </div>
          <!-- <img src="../assets/car_icon.png">
           -->
        </div>
        <!-- env-version="trial" -->
          <!-- :path="sn?'pages/tabBar/home.html?sn='+sn:'pages/tabBar/home.html'" -->
        <div class="main_block_bottom">
          <wx-open-launch-weapp
            class="wx_btn"
            :username="AppletPrimitiveId"
            :path="pageUrl"
            @launch="handleLaunchFn"
            @error="handleErrorFn"
          >
            <script type="text/wxtag-template">
              <style>
                .open{
                  padding: 15px;
                  text-align: center;
                  margin-top: 20px;
                }
                .btn{
                  background-color: #19be6b;
                  color: white;
                  padding: 15px 30px;
                  border: none;
                  border-radius: 5px;
                  font-size: 20px;
                }
              </style>
              <div class="open">
                <button class="btn">打开小程序</button>
              </div>
            </script>
          </wx-open-launch-weapp>
        </div>
      </template>
      <template v-if="!isWxNavigator">
        <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
          请使用微信打开
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import {searchDevice} from '../api/api';
export default {
  data() {
    return {
      dataList: [],
      search: '',
      isWxNavigator: true,
      pageUrl: '',
      appLogo: '',
      explainUrl: '',
      downUrl: 'https://cv.e5ex.cn/app/qrCode/iphone.png',
      sn: "",
      AppletPrimitiveId: "",
      notInStorage_code: "",
      AppName: "",
      snCode: "",
      plate: "",
      type: "C",
      parentNumber: "",
      isResponse: false
    };
  },
  created() {
    // this.checkViewport();
  },
  mounted(){
    if(window.location.href.split('/#/')[1]){
      this.type = window.location.href.split('/#/')[1].slice(-1);
      document.title = '上海融涞';
      if(this.type == 'B'){
        document.title = '深圳策力';
      }
      if(this.type == 'D'){
        document.title = '设备自检';
      }
      if(window.location.href.split('/#/')[1].length > 4){
        this.search = window.location.href.split('/#/')[1].slice(1);
      }
    }
    this.toMiniapp();
  },
  methods: {
    handleLaunchFn(e) {
      console.log('success', e.detail);
        // window.open("https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkzMTE4MDY5MA==#wechat_redirect");
    },
    handleErrorFn(e){
      console.log('fail', e.detail);
    },
    toMiniapp() {
      // document.title = '轮端感知信息牌';
      if(!(this.search && this.search.length > 2)) return
      const params = {
        type: this.type,
        omnipotent: this.search
      }
      searchDevice(params).then(({code, msg, data}) => {
        if (!code) {
          this.AppletPrimitiveId = data.AppletPrimitiveId;
          this.AppName = data.AppName;
          this.pageUrl = data.page;
          this.isResponse = true;
          this.appLogo = data.logo;
          // document.title = this.AppName;
          this.plate = data.plate;
          this.parentNumber = data.parentNumber;
          this.snCode = data.Sn;
          this.dataList = data.examine && data.examine.length ? data.examine : [];
          wx.config({
            debug: false,
            appId: "wxa897b31443ea9c96",
            signature: data.signature,
            nonceStr: data.nonceStr,
            timestamp: data.timestamp,
            jsApiList: [],
            openTagList: ["wx-open-launch-weapp"]
          });
          wx.ready(() => {
            console.log('wx ready')
          });
          wx.error(function (res) {
            console.log("error",res)
          });
          this.notInStorage_code = '';
        } else if (code == -2) {
          // 未入库的设备号
          // this.$message.error(`产品「SN：${data}」未入库，请联系技术支持`);
          this.notInStorage_code = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 查看当前配置
    checkViewport() {
      //判断设备 /R862177043673170
      let u = navigator.userAgent;
      let platform = navigator.platform;
      if (u.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
        this.isWxNavigator = true;
      }else{
        this.isWxNavigator = false;
      }
    }
  }
}
</script>
<style scoped>
input, input:focus{
  font-size: 16px !important;
}
.main_block{
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 15vw 30px 20vw;
  min-height: 100vh;
  box-sizing: border-box;
}
.main_block_list{
  margin-top: 5vw;
}
.main_block_listItem{
  height: 32px;
  line-height: 32px;
  border-bottom: 1px solid #c8c8c8;
}
.main_block_listItem img.state_img{
  width: 30px;
  height: 30px;
  margin: 0;
}
.listItem_right{
  display: flex;
  justify-content: center;
  align-items: center;
}
.listItem_right span{
  margin-right: 5px;
}
.main_block_listItem,
.main_block_search{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80vw;
  position: relative;
}
.main_block_search input{
  height: 32px;
  border: 1px solid #c8c8c8;
  border-radius: 4px;
  padding: 0 10px;
  flex: 1;
  padding-right: 50px;
}
.main_block_search button{
  height: 32px;
  border: 0;
  border-radius: 4px;
  background-color: #2979ff;
  color: #fff;
  padding: 0 10px;
  /* margin-left: 10px; */
  position: absolute;
  top: 1px;
  right: 1px;
}
.main_block_search button.disabled{
  background-color: #c8c8c8;
  color: #000;
}
.main_block_bottom,
.main_block_top{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.main_block_top img{
  height: 60px;
  width: auto;
  margin-bottom: 15px;
}
.main_block_top p{
  color: #808080;
}
.main_block_mid{
  margin-top: 5vw;
}
.wx_btn{
  /* width: 190px;
  height: 60px; */
}
.plate_block{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.plate_text{
  padding: 5px 8px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin: 10px 0 0;
  width: auto;
  background-color: #fec922;
  text-align: center;
  border-radius: 8px;
  margin-bottom: 10px;
}

.btn:active{
  background-color: rgba(25, 190, 107, 0.8);
}

#body {
  height: 100%;
  width: 100%;
  position: absolute;
  background: url("../assets/back.jpg");
  background-size: 80%;
}
.button {
  height: 42px;
  width: 85%;
  margin: 0 auto auto;
  font-size: 20px;
  line-height: 40px;
  color: #808080;
}
</style>



// WEBPACK FOOTER //
// src/components/searchDevice.vue